import {
  ApiRuleConditionTypeInfo,
  Rule,
  RuleConditionContext,
  RuleGroup,
  RuleGroupShort,
} from "@/types/rule.types.ts";
import * as yup from "yup";

export function getWorkflowRuleGroups(
  groups: RuleGroup[] | null | undefined,
  legacyRules: Rule[] | null | undefined,
  isSupportedRule?: (rule: Rule) => boolean
): RuleGroup[] {
  const source = groups ?? (legacyRules?.length ? [{ rules: legacyRules }] : []);
  return source
    .map((group) => ({
      rules: (isSupportedRule ? group.rules.filter(isSupportedRule) : group.rules).map((rule) => ({
        ...rule,
        value_ids: rule.value_ids ?? [],
      })),
      hadRules: group.rules.length > 0,
    }))
    .filter((group) => group.rules.length > 0 || !group.hadRules)
    .map(({ rules }) => ({ rules }));
}

export function toWorkflowRuleGroupsPayload(groups: RuleGroup[]): RuleGroupShort[] {
  return groups
    .filter((group) => group.rules.length > 0)
    .map((group) => ({
      rules: group.rules.map((rule) => ({
        condition_type: rule.condition_type,
        sign: rule.sign,
        condition_ids: rule.condition_ids,
        value_ids: rule.value_ids,
        date_condition: rule.date_condition,
      })),
    }));
}

export const workflowRuleGroupsSchema = () =>
  yup
    .array()
    .of(
      yup.object({
        rules: yup.array().of(yup.mixed<Rule>().required()).required(),
      })
    )
    .required();

export function canPreviewWorkflowRuleGroups(
  groups: RuleGroup[] | undefined,
  conditionTypes: ApiRuleConditionTypeInfo[]
): boolean {
  return (groups ?? []).every((group) =>
    group.rules.every((rule) =>
      conditionTypes.some(
        (type) =>
          type.condition_type === rule.condition_type && type.context === RuleConditionContext.none
      )
    )
  );
}
